import {createReducer} from '@reduxjs/toolkit';

import {CartTotalsType} from 'types/cartType';

import {setDataFromHostStore} from '../../actions';
import {getQuote, removeQuoteItem} from '../quoteItems/quoteItems';

export const initialValue: CartTotalsType = {
    appliedCoupons: [''],
    copay: '',
    discount: '0',
    messages: [{message: '', type: ''}],
    shippingDiscount: '',
    shippingMethod: '0',
    shippingPrice: '0',
    subtotal: '0',
    tax: '0',
    total: '0',
};

/**
 * Get cart quote totals
 *
 * @param {CartTotalsType} state - Current state
 * @param {ActionType<AxiosPromise>} action - Received action
 * @returns {CartTotalsType} Cart quote totals data
 */
export const cartTotals = createReducer<CartTotalsType>(initialValue, builder =>
    builder
        .addCase(setDataFromHostStore, (state, action) => action.payload?.totals || state)
        .addCase(getQuote.fulfilled, (_, action) => action.payload?.data.totals)
        .addCase(removeQuoteItem.fulfilled, (_, action) => action.payload?.data.totals),
);
